import {mapFilters} from "@/utils/helpers";

const initState = () => ({
})

export const state = initState

export const getters = {
}

export const mutations = {
}

export const actions = {

  async transferItems({}, {actualItemID, transferItems}){
    let successTransfer = true;
    try {
      const url = `/webpos/items/${actualItemID}/transfer`;
      await this.$axios.$post(url, transferItems)
      this.$toast.success("Items transferred successfully");

    }
    catch (error) {
      successTransfer = false;
      this.$toast.error("Error while transferring items");
    }

    return successTransfer
  },

  async createTransferRequestForItems({}, {actualItemID, transferItems}){
    let successTransfer = true;
    try {
      const url = `/webpos/items/${actualItemID}/transfer-request`;
      await this.$axios.$post(url, transferItems)
      this.$toast.success("Transfer request created successfully");

    }
    catch (error) {
      successTransfer = false;
      this.$toast.error("Error while creating transfer request");
    }

    return successTransfer
  },

  async fetchInventoryTransfers({commit, state}, {pagingInfo, filters, showOutgoingTransfers}){
    const url = `/webpos/transfer/`;
    let customOrders = [];

    let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
    filter.showOutgoingTransfers = showOutgoingTransfers;
    const result = await this.$axios.$get(`${url}?${new URLSearchParams(filter).toString()}`);

    if(result && !result.hasErrors){
      customOrders = result;
    }
    else{
      this.$toast.error('Error while getting custom orders')
    }
    return customOrders;
  },

  async updateInventoryTransferStatus({}, {transferID, transferDetails}){
    let successTransferStatusUpdate = true;
    try {
      const url = `/webpos/transfer/${transferID}/status`;
      let result = await this.$axios.$post(url, transferDetails)
      if(result?.value){
        this.$toast.success("Item status updated successfully");
      }
      else if(result && result.apiMessages.hasErrors && result.apiMessages.serverErrors.length){
        successTransferStatusUpdate = false;
        this.$toast.error(result.apiMessages.serverErrors[0]);
      }
    }
    catch (error) {
      successTransferStatusUpdate = false;
      this.$toast.error("Error while updating item status");

    }

    return successTransferStatusUpdate
  },
}
